export const GET_ADMIN_ACCOUNT = 'store/userAccounts/GET_ADMIN_ACCOUNT'
export const GET_ADMIN_ACCOUNT_LIST = 'store/userAccounts/GET_ADMIN_ACCOUNT_LIST'
export const GET_DEVICE_HISTORY_LIST = 'GET_DEVICE_HISTORY_LIST'
export const SET_SEARCH_PARAMS_ACCOUNTS = 'SET_SEARCH_PARAMS_ACCOUNTS'



// WEBPACK FOOTER //
// ./src/actionTypes/Accounts/userAccounts.js